import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ConvertPriceToString } from '../../../Helpers/CustomConverter';
import { handleInputForQtyAndValueFocus, handleInputKeyPressForQtyAndValueInput, handleOnChangeForQtyAndValueInput, roundValueToCents } from '../../../Helpers/PriceAndValueInputHelpers';

/**
 * DK : Komponent do płatności za dokumnety / limit kredytowy
 * @param {string} docNo numer dokumentu
 * @param {decimal} valueToPay kwota do zapłaty
 * @param {decimal} creditLimit limit kredytowy - jeżeli spłata limitu kredytowego
 * @returns 
 */
const PaymentWithValueModal = ({ show, onHide, docNo, valueToPay, creditLimit }) => {
    // DK : kwota maksymalna zaokrąglona do groszy - inaczej odejmowanie na floatach (np. 441.40 - 300.00) daje 141.39999999999998 i blokuje wpłatę pełnej kwoty
    const maxValueToPay = roundValueToCents(valueToPay)
    const initialValue = isNaN(maxValueToPay) ? '' : maxValueToPay.toFixed(2)
    const [value, setValue] = useState(initialValue)
    const [errorText, setErrorText] = useState(null)

    useEffect(() => {
        if (show) {
            setValue(initialValue)
            setErrorText(null)
        }
    }, [show])

    const validatePaymentAmmount = () => {
        if (!value) {
            setErrorText('Kwota nie może byc pusta!')
            return false
        }
        if (roundValueToCents(value) > 9999999999.99) {
            setErrorText('Przekroczono maksymalną kwotę wpłaty!')
            return false
        }
        if (roundValueToCents(value) <= 0) {
            setErrorText('Niepoprawna kwota wpłaty!')
            return false
        }
        if (roundValueToCents(value) > maxValueToPay && !docNo.toString().startsWith('Spłata')) {
            setErrorText(`Nie możesz wpisac większej kwoty niż: ${ConvertPriceToString(maxValueToPay)}`)
            return false
        }
        return true
    }

    const handleValueKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleAcceptPayment()
        }
        else if (!handleInputKeyPressForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
    }

    const handleValueChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
        setValue(e.target.value)
    }

    const handleValueLostFocus = (e) => {
        validatePaymentAmmount()
    }

    const handleAcceptPayment = () => {
        if (validatePaymentAmmount()) {
            onHide(roundValueToCents(value).toFixed(2))
        }
    }

    return (<Modal size='lg' show={show} onHide={() => onHide(null)} centered>
        <Modal.Header closeButton={true}>
            <Modal.Title>{docNo.toString().startsWith('Spłata') ? 'Spłata limitu kredytowego' : `Zapłata za dokument: ${docNo}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='d-flex flex-column'>
                {creditLimit ?
                    (<span>Dostępny limit kredytowy: <strong>{ConvertPriceToString(creditLimit)}</strong></span>) :
                    (<span>Kwota pozostała do opłacenia: <strong>{ConvertPriceToString(maxValueToPay)}</strong></span>)
                }

                <div className='row mt-3 align-items-center'>
                    <div className="col-12 col-md-4">
                        <span>Kwota którą chcesz wpłacić: </span>
                    </div>
                    <div className="col-12 col-md-8">
                        <input type='text' inputMode='decimal' className='offer-request-input' style={{ width: '200px' }} value={value} onFocus={handleInputForQtyAndValueFocus}
                            onKeyDown={(e) => handleValueKeyDown(e)} onChange={(e) => handleValueChange(e)} onBlur={(e) => handleValueLostFocus(e)}
                        />
                    </div>
                </div>
                <span className='mt-3 error-text-color'>{errorText}</span>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <button className='btn-app-primary me-3' onClick={handleAcceptPayment}>Wpłać</button>
            <button className='btn-app-secondary' onClick={() => onHide(null)}>Anuluj</button>
        </Modal.Footer>
    </Modal>)
}

export default PaymentWithValueModal